/**
 * trønso: Sprungmarken, die wirklich ankommen.
 *
 * Zwei Fälle, in denen der normale Sprung des Browsers danebenliegt:
 *
 * 1. Ziel in der klebenden Kaufspalte der Produktseite. Ab 750 px ist die Spalte
 *    `position: sticky` und höher als das Fenster, ihr unteres Ende wird erst sichtbar, wenn die
 *    Galerie daneben zu Ende gescrollt ist. Der Browser scrollt, als stünde das Ziel im Fluss, die
 *    Spalte klebt aber fest, und man sieht nur Produktbilder. Hier wird so weit gescrollt, dass
 *    die Spalte vom Ende ihres Containers hochgeschoben wird.
 *
 * 2. Ziel weit unten, z. B. die Aktionsbedingungen im Footer (Link aus der Ankündigungsleiste).
 *    Das Theme scrollt weich, unterwegs laden Bilder nach, die Seite wird länger, und der Sprung
 *    endet einige hundert Pixel zu früh. Hier wird ohne Animation gesprungen und gut eine Sekunde
 *    lang nachkorrigiert, bis die Position steht.
 *
 * 3. Ziel ist ein Popup (`dialog.tronso-feinschrift-dialog`, z. B. die Aktionsbedingungen aus
 *    `sections/tronso-feinschrift.liquid`): Statt zu scrollen öffnet es sich. Schließen per Kreuz,
 *    Escape oder Klick auf den Schleier.
 *
 * Gesteuert werden nur Anker auf die trønso-Feinschrift (Popup, Footer-Feinschrift, Preishinweis).
 * Alle anderen Anker im Theme, etwa „Zum Inhalt springen", bleiben beim Browser.
 */
(() => {
  if (window.tronsoAnker) return;
  window.tronsoAnker = true;

  const ABSTAND = 24;

  const scrollParent = (el) => {
    for (let e = el.parentElement; e; e = e.parentElement) {
      const oy = getComputedStyle(e).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && e.scrollHeight > e.clientHeight) return e;
    }
    return document.scrollingElement;
  };

  const headerUnterkante = () => {
    const h = document.querySelector('#header-component');
    return h ? Math.max(0, h.getBoundingClientRect().bottom) : 0;
  };

  const zielVon = (hash) => {
    const id = decodeURIComponent((hash || '').slice(1));
    const el = id ? document.getElementById(id) : null;
    return el && el.matches('.tronso-feinschrift, .tronso-preishinweis, .tronso-feinschrift-dialog') ? el : null;
  };

  // Um wie viele Pixel muss noch gescrollt werden, damit das Ziel an seinem Platz steht?
  const restweg = (ziel) => {
    let spalte = ziel.parentElement;
    while (spalte && getComputedStyle(spalte).position !== 'sticky') spalte = spalte.parentElement;

    if (spalte && spalte.parentElement) {
      const oben = parseFloat(getComputedStyle(spalte).top) || 0;
      const container = spalte.parentElement.getBoundingClientRect();
      const box = spalte.getBoundingClientRect();
      const versatz = ziel.getBoundingClientRect().top - box.top;
      const stand = ziel.getBoundingClientRect().top - (oben + ABSTAND);
      // Erst wenn die Spalte am Container-Ende anliegt, bewegt sie sich mit. Bis dahin fehlt so viel:
      const bisAnliegen = container.bottom - box.bottom;
      return bisAnliegen > 0 ? container.bottom - box.height + versatz - (oben + ABSTAND) : stand;
    }

    return ziel.getBoundingClientRect().top - (headerUnterkante() + ABSTAND);
  };

  const oeffne = (dialog) => {
    if (dialog.open) return;
    dialog.showModal();
    if (dialog.dataset.tronsoBereit) return;
    dialog.dataset.tronsoBereit = '1';
    // Klick auf den Schleier: Der fällt auf das <dialog> selbst, nicht auf seinen Inhalt.
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) dialog.close();
    });
    // Anker aus der Adresse nehmen, damit ein Neuladen das Fenster nicht wieder öffnet.
    dialog.addEventListener('close', () => {
      if (location.hash === '#' + dialog.id) history.replaceState(null, '', location.pathname + location.search);
    });
  };

  let lauf = 0;
  const springe = (ziel) => {
    if (!ziel) return;
    if (ziel.tagName === 'DIALOG') return oeffne(ziel);
    const scroller = scrollParent(ziel);
    const nr = ++lauf;
    const ende = performance.now() + 1200;

    const schritt = () => {
      if (nr !== lauf) return;
      const max = scroller.scrollHeight - scroller.clientHeight;
      const soll = Math.min(max, Math.max(0, scroller.scrollTop + restweg(ziel)));
      // `instant`, weil das Theme weiches Scrollen setzt: sonst misst die Korrektur mitten im Lauf.
      if (Math.abs(soll - scroller.scrollTop) > 2) scroller.scrollTo({ top: soll, behavior: 'instant' });
      if (performance.now() < ende) requestAnimationFrame(schritt);
    };
    schritt();
  };

  // Seite wurde mit Anker aufgerufen: nach dem Laden einmal ausrichten (Bilder ändern die Höhen).
  const nachLaden = () => requestAnimationFrame(() => springe(zielVon(location.hash)));
  if (document.readyState === 'complete') nachLaden();
  else window.addEventListener('load', nachLaden, { once: true });

  window.addEventListener('hashchange', () => springe(zielVon(location.hash)));

  document.addEventListener('click', (e) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest('a[href*="#"]');
    if (!a || a.origin !== location.origin || a.pathname !== location.pathname) return;
    const ziel = zielVon(a.hash);
    if (!ziel) return;
    e.preventDefault();
    if (ziel.tagName !== 'DIALOG' && location.hash !== a.hash) history.pushState(null, '', a.hash);
    springe(ziel);
  });
})();
